export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1629447388369-760612337eff?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  incident: "https://images.unsplash.com/photo-1670689334015-299d6559b3c3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  blueprint: "https://images.unsplash.com/photo-1542621334-a254cf47733d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  corroded: "https://images.unsplash.com/photo-1695143339807-89a3093982a7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  weld: "https://images.unsplash.com/photo-1746721437832-bcf682d2addc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  control: "https://images.unsplash.com/photo-1653108951561-b9198632de97?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const TIMELINE = [
  {
    t: "02:47:10",
    title: "Shift handover logged — Unit 4 Hydrocracker",
    desc: "Board operator confirms feed rate stable at 142 m³/h. Reactor E-401 outlet temperature reading 318 °C, within the 305–340 °C operating band. No open alarms.",
  },
  {
    t: "03:11:38",
    title: "Skin thermocouple T-99 trend flattens",
    desc: "T-99 (E-401 outlet skin TC) holds at 318 °C while redundant thermowell TW-99B climbs. Deviation not flagged — reading remained inside configured range clamp.",
  },
  {
    t: "03:13:50",
    title: "Separator V-402 pressure begins rising",
    desc: "PT-402 records 41.2 barg climbing at ~0.4 bar/s. Design pressure of V-402 is 46 barg. Temperature controller continues firing charge heater H-401.",
  },
  {
    t: "03:14:02",
    title: "V-402 shell rupture along longitudinal seam",
    desc: "Ductile overpressure failure initiates at the heat-affected zone of the longitudinal weld. Relief valve PSV-402 does not lift. Loss of primary containment.",
    danger: true,
  },
  {
    t: "03:14:19",
    title: "Manual emergency depressurization initiated",
    desc: "Board operator opens BDV-410 to flare. Unit isolated. No personnel in the immediate area. Incident classified LOPC-2 (Loss of Primary Containment).",
  },
];

export const EVIDENCE = [
  {
    tag: "EXHIBIT A",
    img: "weld",
    title: "Weld fractography — V-402 longitudinal seam",
    meta: "METALLURGY LAB / SEM 200x",
    body: "Fracture surface shows ductile dimpling with beach marks consistent with thermal-mechanical fatigue initiating at the weld HAZ. No pre-existing inclusions or manufacturing voids detected.",
    conf: "MATERIAL DEFECT: RULED OUT",
  },
  {
    tag: "EXHIBIT B",
    img: "corroded",
    title: "Relief bypass valve V-402A — as-found position",
    meta: "FIELD SURVEY / TAG V-402A",
    body: "Manual isolation valve on the PSV-402 inlet found ~40% open. Car-seal broken and absent. Diverts a portion of relief capacity away from the flare header.",
    conf: "RELIEF PATH: COMPROMISED",
  },
  {
    tag: "EXHIBIT C",
    img: "blueprint",
    title: "As-built P&ID vs field verification",
    meta: "DOC REV F-401-04 / MOC-2231",
    body: "March turnaround work order for a flush of V-402A has no closing car-seal check recorded. Management-of-Change MOC-2231 left open. Line-up not verified at restart.",
    conf: "PROCEDURE GAP: CONFIRMED",
  },
];

export const WITNESS = [
  {
    role: "Lead Board Operator",
    id: "STMT-01 / 09:12",
    quote:
      "Around 03:13 I noticed the T-99 trend went flat while the downstream temperatures kept climbing. It didn't add up, but the DCS never raised an alarm so I had nothing to action on.",
  },
  {
    role: "Field Operator, Unit 4",
    id: "STMT-02 / 10:40",
    quote:
      "There was a rising high-pitch whine near the E-401 skid maybe a minute before it let go. I called it in on the radio. By the time I reached the stairwell I heard the release.",
  },
  {
    role: "Maintenance Supervisor",
    id: "STMT-03 / 13:05",
    quote:
      "V-402A was opened during the March turnaround for a flush. I can't find a record of it being car-sealed shut afterward. That step lives on the turnaround punch list, not the daily rounds.",
  },
];

export const SENSORS = [
  { tag: "T-99  E-401 SKIN TC", reading: "318.0 °C", actual: "361.4 °C", status: "DRIFT −43.4 °C", danger: true },
  { tag: "TW-99B REDUNDANT TW", reading: "361.4 °C", actual: "361.4 °C", status: "OK", danger: false },
  { tag: "PT-402 V-402 PRESS", reading: "47.9 barg", actual: "> 46 DESIGN", status: "OVERPRESSURE", danger: true },
  { tag: "FT-401 CHARGE FLOW", reading: "142 m³/h", actual: "142 m³/h", status: "NOMINAL", danger: false },
  { tag: "PSV-402 LIFT SENSE", reading: "NO LIFT", actual: "EXPECTED", status: "FAIL-TO-OPEN", danger: true },
  { tag: "TIC-401 HTR DEMAND", reading: "74 %", actual: "SHOULD < 55%", status: "OVERFIRING", danger: true },
];

export const HYPOTHESES = [
  {
    id: "H-A",
    title: "Primary shell material / manufacturing defect",
    conf: 11,
    verdict: "REJECTED",
    body: "Fractography indicates fatigue initiation at the weld HAZ, not a pre-existing inclusion or fabrication flaw. Vessel passed last internal inspection with no relevant findings.",
  },
  {
    id: "H-B",
    title: "Operator error / manual overpressure",
    conf: 22,
    verdict: "PARTIAL",
    body: "Manual actions during the event were correct given the information displayed. The board operator was reacting to instrument readings that were themselves incorrect. Not a root cause.",
  },
  {
    id: "H-C",
    title: "T-99 calibration drift + bypassed relief path",
    conf: 94,
    verdict: "SUPPORTED",
    primary: true,
    body: "A −43 °C offset on skin TC T-99 caused TIC-401 to over-fire H-401, driving V-402 above design temperature and pressure. Relief valve protection was diverted by the partially-open V-402A left after the March turnaround.",
  },
];
